import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top whenever the route pathname changes. Mount
 * once inside <BrowserRouter>. Honors hash anchors (e.g. /pricing#starter)
 * and respects user reduced-motion preference.
 */
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If the URL has a #anchor, let the browser handle it instead of jumping
    // to the top.
    if (hash) return;
    const prefersReducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, left: 0, behavior: prefersReducedMotion ? "auto" : "instant" });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
